import {
  IcHome, IcBowl, IcWellness, IcBag, IcCar, IcBook, IcMask, IcPlane, IcHeart, IcSparkle,
  IcBriefcase, IcUser, IcChart, IcSparkAlt, IcSeed,
} from '../components/ui/Icons'

export const CATEGORIAS_GASTO = [
  { icon: IcHome,     label: 'Hogar',        emoji: '🏠' },
  { icon: IcBowl,     label: 'Comida',        emoji: '🍽️' },
  { icon: IcWellness, label: 'Bienestar',     emoji: '🌸' },
  { icon: IcBag,      label: 'Compras',       emoji: '🛍️' },
  { icon: IcCar,      label: 'Transporte',    emoji: '🚗' },
  { icon: IcBook,     label: 'Aprendizaje',   emoji: '📚' },
  { icon: IcMask,     label: 'Experiencias',  emoji: '🎭' },
  { icon: IcPlane,    label: 'Viajes',        emoji: '✈️' },
  { icon: IcHeart,    label: 'Amor',          emoji: '💜' },
  { icon: IcSparkle,  label: 'Otro',          emoji: '⚡' },
]

export const CATEGORIAS_INGRESO = [
  { icon: IcBriefcase, label: 'Salario',      emoji: '💼' },
  { icon: IcUser,      label: 'Freelance',    emoji: '💻' },
  { icon: IcChart,     label: 'Inversiones',  emoji: '📈' },
  { icon: IcHeart,     label: 'Regalo',       emoji: '🎁' },
  { icon: IcBag,       label: 'Venta',        emoji: '🏷️' },
  { icon: IcSparkAlt,  label: 'Bono',         emoji: '💰' },
  { icon: IcSeed,      label: 'Negocio',      emoji: '🌱' },
  { icon: IcSparkle,   label: 'Otro',         emoji: '⚡' },
]
